<template>
  <div>
    <b-modal
      id="modalInfo"
      v-model="isOpen"
      modal-class="modalInfo"
      :title="$t('label_evaluation_requirementEvaluation_evaluationComments')"
      @close="closeModal()"
    >
      <b-container style="text-align: left">
        <b-form-group
          id="comment"
          :label="
            $t(
              'label_evaluation_requirementEvaluation_evaluationComments_description'
            )
          "
          label-for="comment"
        >
          <b-input-group>
            <b-textarea id="comment" v-model="comment.comment" />
          </b-input-group>
        </b-form-group>
        <b-row>
          <b-col>
            <span class="label">
              {{ $t("label_evaluation_requirementEvaluation_post_category") }}
            </span>
          </b-col>
          <b-col>
            <b-form-group>
              <b-form-radio
                v-model="comment.category"
                name="category"
                value="label_evaluation_requirementEvaluation_post_general"
              >
                {{ $t("label_evaluation_requirementEvaluation_post_general") }}
              </b-form-radio>
              <b-form-radio
                v-model="comment.category"
                name="category"
                value="label_evaluation_requirementEvaluation_post_commitment"
              >
                {{
                  $t("label_evaluation_requirementEvaluation_post_commitment")
                }}
              </b-form-radio>
              <b-form-radio
                v-model="comment.category"
                name="category"
                value="label_evaluation_requirementEvaluation_post_documentation"
              >
                {{
                  $t(
                    "label_evaluation_requirementEvaluation_post_documentation"
                  )
                }}
              </b-form-radio>
              <b-form-radio
                v-model="comment.category"
                name="category"
                value="label_evaluation_requirementEvaluation_post_establishment"
              >
                {{
                  $t(
                    "label_evaluation_requirementEvaluation_post_establishment"
                  )
                }}
              </b-form-radio>
              <b-form-radio
                v-model="comment.category"
                name="category"
                value="label_evaluation_requirementEvaluation_post_execution"
              >
                {{
                  $t("label_evaluation_requirementEvaluation_post_execution")
                }}
              </b-form-radio>
              <b-form-radio
                v-model="comment.category"
                name="category"
                value="label_evaluation_requirementEvaluation_post_specialObservations"
              >
                {{
                  $t(
                    "label_evaluation_requirementEvaluation_post_specialObservations"
                  )
                }}
              </b-form-radio>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <span class="label">
              {{ $t("label_evaluation_requirementEvaluation_post_scope") }}
            </span>
          </b-col>
          <b-col>
            <b-form-group>
              <b-form-radio
                v-model="comment.scope"
                name="scope"
                value="label_evaluation_requirementEvaluation_post_privateComment"
              >
                {{
                  $t(
                    "label_evaluation_requirementEvaluation_post_privateComment"
                  )
                }}
              </b-form-radio>
              <b-form-radio
                v-model="comment.scope"
                name="scope"
                value="label_evaluation_requirementEvaluation_post_includeInFinalReport"
              >
                {{
                  $t(
                    "label_evaluation_requirementEvaluation_post_includeInFinalReport"
                  )
                }}
              </b-form-radio>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <span class="label">
              {{ $t("label_evaluation_requirementEvaluation_post_visibility") }}
            </span>
          </b-col>
          <b-col>
            <b-form-group>
              <b-form-radio
                v-model="comment.visibility"
                name="visibility"
                value="label_evaluation_requirementEvaluation_post_onlyVisibleToEvaluationTeam"
              >
                {{
                  $t(
                    "label_evaluation_requirementEvaluation_post_onlyVisibleToEvaluationTeam"
                  )
                }}
              </b-form-radio>
              <b-form-radio
                v-model="comment.visibility"
                name="visibility"
                value="label_evaluation_requirementEvaluation_post_visibleToOrganization"
              >
                {{
                  $t(
                    "label_evaluation_requirementEvaluation_post_visibleToOrganization"
                  )
                }}
              </b-form-radio>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <span class="label">
              {{ $t("label_evaluation_requirementEvaluation_post_tag") }}
            </span>
          </b-col>
          <b-col>
            <b-form-checkbox v-model="comment.opportunity" name="opportunity">
              {{
                $t(
                  "label_evaluation_requirementEvaluation_post_tag_opportunityArea"
                )
              }}
            </b-form-checkbox>
          </b-col>
        </b-row>
      </b-container>
      <div slot="modal-footer" class="w-100" style="text-align: right">
        <b-button
          variant="primary"
          :disabled="!comment.comment || !comment.visibility || !comment.scope || !comment.category"
          @click="postComment()"
        >
          {{ $t("label_evaluation_requirementEvaluation_post_button") }}
        </b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { cloneDeep } from "lodash";

export default {
  name: "EvaluationCommentsModal",
  props: {
    isReply: {
      type: Boolean,
      default: false,
    },
    showModalComment: {
      type: Boolean,
      default: false,
    },
    comment: {
      type: Object,
      default: () => {},
    },
    index: {
      type: Number,
      default: -1,
    },
    parentCommentIndex: {
      type: Number,
      default: null,
    },
  },
  computed: {
    isOpen: {
      get: function () {
        return this.showModalComment;
      },
      set: function (newValue) {
        this.$emit("update:showModalComment", newValue);
      },
    },
    ...mapGetters(["getUserAccount"]),
  },
  methods: {
    async postComment() {
      if (this.isReply) {
        if (this.index === -1) {
          let valuesToPush = {};
          let baseCommentPath = `comments.${this.parentCommentIndex}.replies`;
          let comment = cloneDeep(this.comment);
          comment["account"] = { account: this.getUserAccount };
          comment["date"] = new Date().toLocaleDateString("en-US");

          valuesToPush[baseCommentPath] = comment;

          await this.$store.dispatch("updateEvaluation", {
            valuesToPush: valuesToPush,
          });
        } else {
          let valuesToUpdate = {};
          let baseCommentPath = `comments.${this.parentCommentIndex}.replies.${this.index}`;
          let comment = cloneDeep(this.comment);
          comment[`editedAccount`] = { account: this.getUserAccount };
          comment[`editedDate`] = new Date().toLocaleDateString("en-US");

          Object.keys(comment).forEach((key) => {
            valuesToUpdate[`${baseCommentPath}.${key}`] = comment[key];
          });

          await this.$store.dispatch("updateEvaluation", {
            valuesToUpdate: valuesToUpdate,
          });
        }
      } else {
        if (this.index === -1) {
          let valuesToPush = {};
          let baseCommentPath = "comments";
          let comment = cloneDeep(this.comment);
          comment["account"] = { account: this.getUserAccount };
          comment["date"] = new Date().toLocaleDateString("en-US");

          valuesToPush[baseCommentPath] = comment;

          await this.$store.dispatch("updateEvaluation", {
            valuesToPush: valuesToPush,
          });
        } else {
          let valuesToUpdate = {};
          let baseCommentPath = `comments.${this.index}`;
          let comment = cloneDeep(this.comment);
          comment[`editedAccount`] = { account: this.getUserAccount };
          comment[`editedDate`] = new Date().toLocaleDateString("en-US");

          Object.keys(comment).forEach((key) => {
            valuesToUpdate[`${baseCommentPath}.${key}`] = comment[key];
          });

          await this.$store.dispatch("updateEvaluation", {
            valuesToUpdate: valuesToUpdate,
          });
        }
      }
      this.isOpen = false;
    },
    postSubcomment() {
      //var comment = this.requirement.comments[this.comment.indexComment]
    },
    editComment(index) {
      this.requirement.comments[index].editedAccount = this.account;
      this.requirement.comments[index].editedDate =
        new Date().toLocaleDateString("en-US");
      this.requirement.comments[index].edit = false;
      this.saveAndForce();
    },
    closeModal() {
      this.isOpen = false;
    },
  },
};
</script>

<style lang="sass"></style>
